<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['links']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title']
            }),
            new fields.Input({
              label: 'Tekst nad tytułem',
              modelPath: [this, 'form', 'up_title']
            }),
            new fields.Input({
              label: 'Treść',
              type: 'textarea',
              modelPath: [this, 'form', 'text']
            }),
            {
              component: 'h3',
              innerText: 'Linki'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'links'],
              items: this.form.links.map((item, i) => ({
                headerLabel: get(item, ['title']),
                fields: [
                  new fields.Link({
                    label: 'Link',
                    required: true,
                    modelPath: [this, 'form', 'links', i]
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
